export default __webpack_public_path__ + "static/media/geo-alt.567b3564.svg";